import { AbstractStruct } from '@pushly/models/lib/structs/abstract-struct'
import { Expose } from 'class-transformer'
import { IsIn } from 'class-validator'
import { getEnumValues } from '@pushly/models'
import { DomainSecretType } from '@pushly/models/lib/enums/domain-secret-type'

export declare function isSecretsModel(obj: any): obj is SecretsModel;

export class SecretsModel extends AbstractStruct {
    @Expose()
    public alias: string;

    @Expose()
    public type: DomainSecretType;

    @Expose()
    public value: string
}